import { Fragment } from 'react'
import Linked from 'shared-components/service/Linked'
import { publicConfig } from 'config'
import { memberHref } from 'lib/community/model'
import { TEAM_TOKEN, mentionText, replyRuns } from 'lib/community/mentions'
import styles from './ReplyRuns.module.css'

/** The links a reader wrote: never endorsed, never followed by a crawler, no opener. */
export const UGC_REL = 'ugc nofollow noopener'

interface ReplyRunsProps {
  /** One line of a reply body (no newline). */
  line: string
  /** Handles this page knows (lowercased): only these read as a mention and link a member page. */
  known: ReadonlySet<string>
}

/**
 * One line of a reply as phrasing content (no block, no link card): http(s) URLs linked
 * `rel="ugc nofollow noopener"`, `@sg-team` read "@SoundGuys team", a known `@handle` linking its
 * member page — an unknown one stays text. `ReplyBody` wraps each line in a paragraph and adds the
 * link cards; the feed row's reply preview draws its one line inside its own clamped paragraph.
 */
const ReplyRuns: React.VFC<ReplyRunsProps> = ({ line, known }) => {
  const trailingSlash = Boolean(publicConfig('useTrailingSlash'))
  const runs = replyRuns(line, token => known.has(token))
  return (
    <>
      {runs.map((run, j) => {
        if ('href' in run) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <a key={j} href={run.href} rel={UGC_REL} target="_blank">
              {run.text}
            </a>
          )
        }
        if ('token' in run) {
          if (run.token === TEAM_TOKEN) {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <span key={j} className={styles.mention}>
                {mentionText(run)}
              </span>
            )
          }
          return (
            <Linked
              // eslint-disable-next-line react/no-array-index-key
              key={j}
              href={memberHref(run.token, trailingSlash)}
              className={styles.mention}
            >
              {mentionText(run)}
            </Linked>
          )
        }
        // eslint-disable-next-line react/no-array-index-key
        return <Fragment key={j}>{run.text}</Fragment>
      })}
    </>
  )
}

export default ReplyRuns
